import React, {useEffect, useState} from "react";
import {IconButton, Popover} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import Done from '@material-ui/icons/DoneOutlined';
import Cancel from '@material-ui/icons/ClearOutlined';
import {useDispatch, useSelector} from "react-redux";
import ServiceGroupsFilter from "../../statistic/filters/ServiceGroupsFilter";
import {loadCapServiceGroups, saveOrUpdateCapServiceGroup} from "../../../../actions/capServiceGroupActions";


export default function CapServicePopover({button, capService}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const dispatch = useDispatch();

    let {subscriptionServiceGroups} = useSelector(state => state.filterDataReducer.filterData);
    const [selectedServiceGroups, setSelectedServiceGroups] = useState([]);
    const [editableCapServiceName, setEditableCapServiceName] = useState(null);
    const [selectedServiceIds, setSelectedServiceIds] = useState([]);

    useEffect(() => {
        if (!capService || !subscriptionServiceGroups || !anchorEl) {
            return;
        }
        setEditableCapServiceName(capService.name);
        const selectedServiceGroups = subscriptionServiceGroups.flatMap(group => group.subscriptionServices.map(service => service))
            .filter(service => capService.serviceIds.includes(service.externalId))
            .map(service => {return {...service, fullName: service.externalId + ' | ' + service.name}});
        setSelectedServiceGroups(selectedServiceGroups);
    }, [capService, subscriptionServiceGroups, anchorEl]);


    useEffect(() => {
        let serviceIds = selectedServiceGroups?.filter(serviceGroup => serviceGroup.isGroup)
            .map(group => group.id)
            .flatMap(groupId => subscriptionServiceGroups.filter(group => group.id===groupId).flatMap(group => group.subscriptionServices.map(service => service.externalId)));
        serviceIds = [...serviceIds, ...selectedServiceGroups?.filter(serviceGroup => !serviceGroup.isGroup).map(service => service.externalId)];
        setSelectedServiceIds(serviceIds);
    }, [selectedServiceGroups]);


    const handleClick = (e) => {
        console.log("handleClick")
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedServiceGroups([]);
        setSelectedServiceIds([]);
        setEditableCapServiceName(null);
    };

    const saveOrUpdateParameter = () => {

        const capServiceItem = {
            id: capService?.id,
            name: editableCapServiceName,
            serviceIds: selectedServiceIds,
        }
        dispatch(saveOrUpdateCapServiceGroup(capServiceItem, () => dispatch(loadCapServiceGroups())));
        handleClose();
    };

    const popover = () => {
        return (
            <Popover id={id}
                     open={open}
                     anchorEl={anchorEl}
                     onClose={handleClose}
                     anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'right',
                     }}
                     transformOrigin={{
                         vertical: 'top',
                         horizontal: 'right',
                     }}
            >
                <div style={{padding: "10px", textAlign: "center"}}>
                    {capService?.id ? "Редактировать" : "Создать"}
                </div>
                <div style={{padding: "10px", minWidth: "305px", maxWidth: "500px"}}>
                    <TextField label="Название"
                               name="name"
                               value={editableCapServiceName || ""}
                               onChange={(e) => setEditableCapServiceName(e.target.value)}
                               InputLabelProps={{shrink: true}}
                               style={{width: '100%', paddingBottom: '15px'}}
                    />
                    <ServiceGroupsFilter handleChangeFilterData={(type, value) => setSelectedServiceGroups(value)}
                                         selectedServiceGroups={selectedServiceGroups}
                                         label='Группы сервисов'/>
                    <br/>
                    <br/>
                    <div className="text-right">
                        <IconButton disableFocusRipple size="medium" onClick={saveOrUpdateParameter}
                                    variant="contained"
                                    title="Сохранить параметр">
                            <Done fontSize="medium"/>
                        </IconButton>
                        <IconButton disableFocusRipple size="medium" onClick={handleClose} variant="contained"
                                    title="Отмена">
                            <Cancel fontSize="medium"/>
                        </IconButton>
                    </div>
                </div>
            </Popover>
        )
    };

    return (
        <>
            <div className="" onClick={handleClick}>
                {button}
            </div>
            {anchorEl && popover()}
        </>
    );
}